// Multi-language translations
export const translations = {
  en: {
    appName: "SocialHub",
    tagline: "Meet people, share moments, live local.",
    heroSub: "An AI-matched community where neighbors with shared interests form real meetups within 5 km.",
    getStarted: "Get Started",
    login: "Sign In",
    register: "Create Account",
    logout: "Sign Out",
    alias: "Alias",
    password: "Password",
    city: "City",
    languages: "Languages spoken",
    primaryActivities: "Primary activities",
    secondaryActivities: "Other interests (free text)",
    secondaryHint: "Comma-separated, e.g. yoga, salsa, board games",
    preferredGroupSize: "Preferred group size",
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    welcome: "Welcome back",
    createAccount: "Create your account",
    haveAccount: "Already have an account?",
    noAccount: "New here?",
    discover: "Discover",
    chats: "Chats",
    groups: "Groups",
    invites: "Invites",
    calendar: "Calendar",
    yourCalendar: "Your calendar",
    calendarSubtitle: "Your AI-curated meetup ideas, on a calendar.",
    hasEvents: "Has events",
    event: "event",
    eventsLabel: "events",
    nothingScheduled: "Nothing scheduled.",
    browseIdeas: "Browse AI ideas",
    addToCalendar: "Add to calendar",
    addedToCalendar: "Added to your calendar",
    confirmSchedule: "Schedule it",
    time: "Time",
    date: "Date",
    title: "Title",
    titleRequired: "Title is required",
    createEvent: "Create event",
    eventCreated: "Event posted to group chat",
    newEvent: "New event",
    eventTitlePlaceholder: "e.g. Friday Football",
    youAccepted: "You're going",
    youDeclined: "You declined",
    going: "Going",
    declined: "Declined",
    responded: "Responded",
    profile: "Profile",
    verified: "Verified",
    notVerified: "Not verified",
    verifyMe: "Verify me",
    yourMatches: "Your matches",
    matchSubtitle: "People nearby with shared interests",
    distance: "Distance",
    commonInterests: "Shared interests",
    commonLanguages: "Shared languages",
    sameCity: "Same city",
    messageThem: "Message",
    inviteToGroup: "Invite to a group",
    chooseGroup: "Choose a group",
    sendInvite: "Send invite",
    noGroups: "You haven't joined any groups yet.",
    createGroup: "Create group",
    groupName: "Group name",
    description: "Description",
    activity: "Activity",
    maxMembers: "Max members (up to 10)",
    members: "Members",
    full: "Full",
    leaveGroup: "Leave group",
    groupChat: "Group chat",
    typeMessage: "Type a message…",
    send: "Send",
    aiSuggest: "AI activity suggestions",
    suggestForGroup: "Suggest activities",
    pending: "Pending",
    accept: "Accept",
    reject: "Decline",
    noInvites: "No pending invites.",
    noChats: "No conversations yet. Discover people to start chatting!",
    enableLocation: "Enable precise location",
    useMyLocation: "Use my current location",
    locationCaptured: "Location captured",
    radius: "Radius",
    km: "km",
    selectAtLeastOne: "Pick at least one primary activity",
    groupFull: "Group is full",
    invitedSuccess: "Invite sent",
    accountCreated: "Account created — welcome!",
    invalidCreds: "Invalid alias or password",
    aliasTaken: "Alias already taken",
    networkErr: "Network error. Please try again.",
    discoverEmpty: "No matches yet. Try expanding your interests or radius.",
    suggestions: "Suggestions",
    why: "Why it fits",
    you: "You",
    online: "online",
    language: "Language",
    settings: "Settings",
    yourProfile: "Your profile",
    saving: "Saving…",
    saved: "Saved",
    of: "of",
    members_count: "members",
    removePhoto: "Remove photo",
    notifications: "Notifications",
    noNotifications: "You're all caught up.",
    markAllRead: "Mark all as read",
    unread: "unread",
    events: "Events",
    aiCuratedEvents: "AI-curated events",
    eventsSubtitle: "Personalized meetup ideas based on your interests and your groups.",
    forYou: "For you",
    forGroup: "For group",
    generateEvents: "Generate ideas",
    refreshIdeas: "Refresh ideas",
    coverRegenerated: "New cover ready",
    allCategories: "All",
    generating: "Thinking…",
    eventsGenerated: "5 new ideas ready!",
    noEvents: "No events yet",
    noEventsHint: "Tap “Generate ideas” to get 5 fresh AI meetup ideas tailored to you or one of your groups.",
    openGroup: "Open group",
    planWithGroup: "Plan with group",
    messages: "Messages",
    connect: "Connect",
    requested: "Requested",
    accepted: "Accepted",
    message: "Message",
    connectRequestSent: "Connection request sent",
    nowConnected: "You're now connected",
    connectFirst: "Connect first to chat",
    noConnections: "No conversations yet. Connect with people on Discover to start chatting.",
    connectionRequest: "Connection request",
    wantsToConnect: "wants to connect",
    decline: "Decline",
    typing: "typing…",
    lastSeen: "last seen",
    justNow: "just now",
    minutesAgo: "m ago",
    hoursAgo: "h ago",
    daysAgo: "d ago",
    source: "Source",
    sourceAll: "All",
    sourceCurated: "Curated",
    sourceAI: "AI-generated",
    sourceSaved: "Saved",
    curated: "Curated",
    save: "Save for later",
    unsave: "Remove from saved",
    noSavedYet: "Nothing saved yet",
    noSavedHint: "Tap the heart on an idea to keep it for later.",
    browseIdeas: "Browse ideas",
  },
  es: {
    appName: "SocialHub",
    tagline: "Conoce personas, comparte momentos, vive lo local.",
    heroSub: "Una comunidad con IA donde vecinos con intereses comunes organizan encuentros reales en 5 km.",
    getStarted: "Comenzar",
    login: "Entrar",
    register: "Crear cuenta",
    logout: "Salir",
    alias: "Apodo",
    password: "Contraseña",
    city: "Ciudad",
    languages: "Idiomas que hablas",
    primaryActivities: "Actividades principales",
    secondaryActivities: "Otros intereses (texto libre)",
    secondaryHint: "Separa por comas: yoga, salsa, juegos…",
    preferredGroupSize: "Tamaño de grupo preferido",
    save: "Guardar",
    cancel: "Cancelar",
    submit: "Enviar",
    welcome: "Bienvenido",
    createAccount: "Crea tu cuenta",
    haveAccount: "¿Ya tienes cuenta?",
    noAccount: "¿Nuevo aquí?",
    discover: "Descubrir",
    chats: "Chats",
    groups: "Grupos",
    invites: "Invitaciones",
    calendar: "Calendario",
    yourCalendar: "Tu calendario",
    calendarSubtitle: "Tus ideas de encuentros con IA, en un calendario.",
    hasEvents: "Con eventos",
    event: "evento",
    eventsLabel: "eventos",
    nothingScheduled: "Nada agendado.",
    browseIdeas: "Ver ideas de IA",
    addToCalendar: "Agendar",
    addedToCalendar: "Agregado al calendario",
    confirmSchedule: "Agendar",
    time: "Hora",
    date: "Fecha",
    title: "Título",
    titleRequired: "Título requerido",
    createEvent: "Crear evento",
    eventCreated: "Evento publicado en el chat",
    newEvent: "Nuevo evento",
    eventTitlePlaceholder: "ej. Fútbol del viernes",
    youAccepted: "Asistirás",
    youDeclined: "Has rechazado",
    going: "Asistirán",
    declined: "Rechazaron",
    responded: "Respondida",
    profile: "Perfil",
    verified: "Verificado",
    notVerified: "Sin verificar",
    verifyMe: "Verificarme",
    yourMatches: "Tus coincidencias",
    matchSubtitle: "Personas cerca con tus intereses",
    distance: "Distancia",
    commonInterests: "Intereses compartidos",
    commonLanguages: "Idiomas compartidos",
    sameCity: "Misma ciudad",
    messageThem: "Mensaje",
    inviteToGroup: "Invitar a un grupo",
    chooseGroup: "Elige un grupo",
    sendInvite: "Enviar invitación",
    noGroups: "Aún no estás en ningún grupo.",
    createGroup: "Crear grupo",
    groupName: "Nombre del grupo",
    description: "Descripción",
    activity: "Actividad",
    maxMembers: "Máx. miembros (hasta 10)",
    members: "Miembros",
    full: "Completo",
    leaveGroup: "Salir del grupo",
    groupChat: "Chat del grupo",
    typeMessage: "Escribe un mensaje…",
    send: "Enviar",
    aiSuggest: "Sugerencias IA de actividades",
    suggestForGroup: "Sugerir actividades",
    pending: "Pendiente",
    accept: "Aceptar",
    reject: "Rechazar",
    noInvites: "Sin invitaciones pendientes.",
    noChats: "Aún no hay conversaciones.",
    enableLocation: "Activar ubicación precisa",
    useMyLocation: "Usar mi ubicación",
    locationCaptured: "Ubicación capturada",
    radius: "Radio",
    km: "km",
    selectAtLeastOne: "Elige al menos una actividad principal",
    groupFull: "Grupo completo",
    invitedSuccess: "Invitación enviada",
    accountCreated: "Cuenta creada — ¡bienvenido!",
    invalidCreds: "Apodo o contraseña inválidos",
    aliasTaken: "Apodo ya en uso",
    networkErr: "Error de red. Inténtalo de nuevo.",
    discoverEmpty: "Sin coincidencias aún.",
    suggestions: "Sugerencias",
    why: "Por qué encaja",
    you: "Tú",
    online: "en línea",
    language: "Idioma",
    settings: "Ajustes",
    yourProfile: "Tu perfil",
    saving: "Guardando…",
    saved: "Guardado",
    of: "de",
    members_count: "miembros",
    removePhoto: "Quitar foto",
    notifications: "Notificaciones",
    noNotifications: "Estás al día.",
    markAllRead: "Marcar todo leído",
    unread: "sin leer",
    events: "Eventos",
    aiCuratedEvents: "Eventos con IA",
    eventsSubtitle: "Ideas personalizadas según tus intereses y tus grupos.",
    forYou: "Para ti",
    forGroup: "Para el grupo",
    generateEvents: "Generar ideas",
    refreshIdeas: "Renovar ideas",
    coverRegenerated: "Nueva portada lista",
    allCategories: "Todas",
    generating: "Pensando…",
    eventsGenerated: "¡5 nuevas ideas listas!",
    noEvents: "Aún no hay eventos",
    noEventsHint: "Toca “Generar ideas” para recibir 5 ideas de encuentros hechas a tu medida.",
    openGroup: "Abrir grupo",
    planWithGroup: "Planear con grupo",
  },
  fr: {
    appName: "SocialHub",
    tagline: "Rencontrez, partagez, vivez local.",
    heroSub: "Une communauté guidée par l'IA pour des rencontres réelles à moins de 5 km.",
    getStarted: "Commencer",
    login: "Connexion",
    register: "Créer un compte",
    logout: "Déconnexion",
    alias: "Pseudo",
    password: "Mot de passe",
    city: "Ville",
    languages: "Langues parlées",
    primaryActivities: "Activités principales",
    secondaryActivities: "Autres centres d'intérêt",
    secondaryHint: "Séparés par des virgules : yoga, salsa…",
    preferredGroupSize: "Taille de groupe préférée",
    save: "Enregistrer",
    cancel: "Annuler",
    submit: "Envoyer",
    welcome: "Bon retour",
    createAccount: "Créez votre compte",
    haveAccount: "Vous avez déjà un compte ?",
    noAccount: "Nouveau ici ?",
    discover: "Découvrir",
    chats: "Chats",
    groups: "Groupes",
    invites: "Invitations",
    calendar: "Calendrier",
    yourCalendar: "Votre calendrier",
    calendarSubtitle: "Vos idées d'événements IA, sur un calendrier.",
    hasEvents: "Avec événements",
    event: "événement",
    eventsLabel: "événements",
    nothingScheduled: "Rien de prévu.",
    browseIdeas: "Voir les idées IA",
    addToCalendar: "Planifier",
    addedToCalendar: "Ajouté au calendrier",
    confirmSchedule: "Planifier",
    time: "Heure",
    date: "Date",
    title: "Titre",
    titleRequired: "Titre requis",
    createEvent: "Créer un événement",
    eventCreated: "Événement publié dans le chat",
    newEvent: "Nouvel événement",
    eventTitlePlaceholder: "ex. Foot du vendredi",
    youAccepted: "Vous y allez",
    youDeclined: "Vous avez refusé",
    going: "Présents",
    declined: "Refusés",
    responded: "Répondu",
    profile: "Profil",
    verified: "Vérifié",
    notVerified: "Non vérifié",
    verifyMe: "Me vérifier",
    yourMatches: "Vos correspondances",
    matchSubtitle: "Personnes près de chez vous avec des intérêts communs",
    distance: "Distance",
    commonInterests: "Intérêts communs",
    commonLanguages: "Langues communes",
    sameCity: "Même ville",
    messageThem: "Message",
    inviteToGroup: "Inviter dans un groupe",
    chooseGroup: "Choisir un groupe",
    sendInvite: "Envoyer l'invitation",
    noGroups: "Aucun groupe pour le moment.",
    createGroup: "Créer un groupe",
    groupName: "Nom du groupe",
    description: "Description",
    activity: "Activité",
    maxMembers: "Membres max (jusqu'à 10)",
    members: "Membres",
    full: "Complet",
    leaveGroup: "Quitter le groupe",
    groupChat: "Discussion de groupe",
    typeMessage: "Écrire un message…",
    send: "Envoyer",
    aiSuggest: "Suggestions IA d'activités",
    suggestForGroup: "Suggérer des activités",
    pending: "En attente",
    accept: "Accepter",
    reject: "Refuser",
    noInvites: "Aucune invitation en attente.",
    noChats: "Pas encore de conversations.",
    enableLocation: "Activer la localisation",
    useMyLocation: "Utiliser ma position",
    locationCaptured: "Position capturée",
    radius: "Rayon",
    km: "km",
    selectAtLeastOne: "Sélectionnez au moins une activité",
    groupFull: "Groupe complet",
    invitedSuccess: "Invitation envoyée",
    accountCreated: "Compte créé — bienvenue !",
    invalidCreds: "Pseudo ou mot de passe invalides",
    aliasTaken: "Pseudo déjà utilisé",
    networkErr: "Erreur réseau. Réessayez.",
    discoverEmpty: "Aucune correspondance pour le moment.",
    suggestions: "Suggestions",
    why: "Pourquoi ça colle",
    you: "Vous",
    online: "en ligne",
    language: "Langue",
    settings: "Paramètres",
    yourProfile: "Votre profil",
    saving: "Enregistrement…",
    saved: "Enregistré",
    of: "sur",
    members_count: "membres",
    notifications: "Notifications",
    noNotifications: "Vous êtes à jour.",
    markAllRead: "Tout marquer comme lu",
    unread: "non lus",
    events: "Événements",
    aiCuratedEvents: "Événements par IA",
    eventsSubtitle: "Idées de rencontres adaptées à vos intérêts et à vos groupes.",
    forYou: "Pour vous",
    forGroup: "Pour le groupe",
    generateEvents: "Générer des idées",
    refreshIdeas: "Actualiser les idées",
    coverRegenerated: "Nouvelle couverture prête",
    allCategories: "Toutes",
    generating: "Réflexion…",
    eventsGenerated: "5 nouvelles idées !",
    noEvents: "Pas encore d'événements",
    noEventsHint: "Appuyez sur « Générer des idées » pour 5 suggestions sur mesure.",
    openGroup: "Ouvrir le groupe",
    planWithGroup: "Planifier en groupe",
  },
  hi: {
    appName: "SocialHub",
    tagline: "लोगों से मिलें, पल बाँटें, स्थानीय जिएँ।",
    heroSub: "AI से मेल खाए हुए पड़ोसी 5 किमी के दायरे में मिलते हैं।",
    getStarted: "शुरू करें",
    login: "साइन इन",
    register: "खाता बनाएँ",
    logout: "साइन आउट",
    alias: "उपनाम",
    password: "पासवर्ड",
    city: "शहर",
    languages: "भाषाएँ",
    primaryActivities: "मुख्य गतिविधियाँ",
    secondaryActivities: "अन्य रुचियाँ",
    secondaryHint: "कॉमा से अलग करें: योग, सालसा…",
    preferredGroupSize: "पसंदीदा समूह आकार",
    save: "सेव करें",
    cancel: "रद्द",
    submit: "भेजें",
    welcome: "वापसी पर स्वागत है",
    createAccount: "अपना खाता बनाएँ",
    haveAccount: "पहले से खाता है?",
    noAccount: "नए हैं?",
    discover: "खोजें",
    chats: "चैट",
    groups: "समूह",
    invites: "निमंत्रण",
    calendar: "कैलेंडर",
    yourCalendar: "आपका कैलेंडर",
    calendarSubtitle: "AI सुझाए इवेंट्स कैलेंडर पर।",
    hasEvents: "इवेंट्स हैं",
    event: "इवेंट",
    eventsLabel: "इवेंट्स",
    nothingScheduled: "कुछ भी नहीं।",
    browseIdeas: "AI विचार देखें",
    addToCalendar: "कैलेंडर में जोड़ें",
    addedToCalendar: "कैलेंडर में जोड़ा गया",
    confirmSchedule: "सहेजें",
    time: "समय",
    date: "तारीख",
    title: "शीर्षक",
    titleRequired: "शीर्षक आवश्यक है",
    createEvent: "इवेंट बनाएँ",
    eventCreated: "इवेंट ग्रुप चैट में पोस्ट हो गया",
    newEvent: "नया इवेंट",
    eventTitlePlaceholder: "जैसे शुक्रवार फुटबॉल",
    youAccepted: "आप जा रहे हैं",
    youDeclined: "आपने मना किया",
    going: "जा रहे हैं",
    declined: "मना किया",
    responded: "उत्तर दिया",
    profile: "प्रोफ़ाइल",
    verified: "सत्यापित",
    notVerified: "असत्यापित",
    verifyMe: "मुझे सत्यापित करें",
    yourMatches: "आपके मैच",
    matchSubtitle: "समान रुचि वाले निकट के लोग",
    distance: "दूरी",
    commonInterests: "समान रुचियाँ",
    commonLanguages: "समान भाषाएँ",
    sameCity: "एक ही शहर",
    messageThem: "संदेश",
    inviteToGroup: "समूह में आमंत्रित करें",
    chooseGroup: "समूह चुनें",
    sendInvite: "निमंत्रण भेजें",
    noGroups: "अभी कोई समूह नहीं।",
    createGroup: "समूह बनाएँ",
    groupName: "समूह का नाम",
    description: "विवरण",
    activity: "गतिविधि",
    maxMembers: "अधिकतम सदस्य (10 तक)",
    members: "सदस्य",
    full: "भरा हुआ",
    leaveGroup: "समूह छोड़ें",
    groupChat: "समूह चैट",
    typeMessage: "संदेश लिखें…",
    send: "भेजें",
    aiSuggest: "AI गतिविधि सुझाव",
    suggestForGroup: "गतिविधियाँ सुझाएँ",
    pending: "लंबित",
    accept: "स्वीकार",
    reject: "अस्वीकार",
    noInvites: "कोई लंबित निमंत्रण नहीं।",
    noChats: "अभी कोई बातचीत नहीं।",
    enableLocation: "स्थान सक्षम करें",
    useMyLocation: "मेरा स्थान उपयोग करें",
    locationCaptured: "स्थान प्राप्त",
    radius: "त्रिज्या",
    km: "किमी",
    selectAtLeastOne: "कम से कम एक गतिविधि चुनें",
    groupFull: "समूह भरा हुआ है",
    invitedSuccess: "निमंत्रण भेजा गया",
    accountCreated: "खाता बना — स्वागत!",
    invalidCreds: "गलत उपनाम या पासवर्ड",
    aliasTaken: "उपनाम पहले से लिया गया",
    networkErr: "नेटवर्क त्रुटि।",
    discoverEmpty: "अभी कोई मैच नहीं।",
    suggestions: "सुझाव",
    why: "क्यों फिट है",
    you: "आप",
    online: "ऑनलाइन",
    language: "भाषा",
    settings: "सेटिंग्स",
    yourProfile: "आपकी प्रोफ़ाइल",
    saving: "सहेज रहे हैं…",
    saved: "सहेजा गया",
    of: "में से",
    members_count: "सदस्य",
    removePhoto: "फोटो हटाएँ",
    notifications: "सूचनाएँ",
    noNotifications: "आप पूरी तरह अपडेट हैं।",
    markAllRead: "सभी पढ़ा हुआ चिह्नित करें",
    unread: "अपठित",
    events: "इवेंट्स",
    aiCuratedEvents: "AI-चयनित इवेंट्स",
    eventsSubtitle: "आपकी रुचियों और समूहों के अनुसार मीटअप विचार।",
    forYou: "आपके लिए",
    forGroup: "समूह के लिए",
    generateEvents: "विचार बनाएँ",
    refreshIdeas: "नए विचार पाएँ",
    coverRegenerated: "नया कवर तैयार",
    allCategories: "सभी",
    generating: "सोच रहे हैं…",
    eventsGenerated: "5 नए विचार तैयार!",
    noEvents: "अभी कोई इवेंट नहीं",
    noEventsHint: "“विचार बनाएँ” पर टैप करें—आपके लिए 5 AI मीटअप विचार पाएँ।",
    openGroup: "समूह खोलें",
    planWithGroup: "समूह के साथ योजना",
  },
  ar: {
    appName: "SocialHub",
    tagline: "تعرّف على الناس، شارك اللحظات، عش محلياً.",
    heroSub: "مجتمع مدعوم بالذكاء الاصطناعي يجمع الجيران ذوي الاهتمامات المشتركة ضمن 5 كم.",
    getStarted: "ابدأ الآن",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "تسجيل الخروج",
    alias: "اسم مستعار",
    password: "كلمة المرور",
    city: "المدينة",
    languages: "اللغات",
    primaryActivities: "الأنشطة الأساسية",
    secondaryActivities: "اهتمامات أخرى",
    secondaryHint: "افصلها بفاصلة: يوغا، سالسا…",
    preferredGroupSize: "حجم المجموعة المفضّل",
    save: "حفظ",
    cancel: "إلغاء",
    submit: "إرسال",
    welcome: "مرحباً بعودتك",
    createAccount: "أنشئ حسابك",
    haveAccount: "لديك حساب؟",
    noAccount: "جديد هنا؟",
    discover: "اكتشف",
    chats: "المحادثات",
    groups: "المجموعات",
    invites: "الدعوات",
    calendar: "التقويم",
    yourCalendar: "تقويمك",
    calendarSubtitle: "أفكار اللقاءات بالذكاء الاصطناعي على تقويم.",
    hasEvents: "يحتوي على فعاليات",
    event: "فعالية",
    eventsLabel: "فعاليات",
    nothingScheduled: "لا شيء مجدول.",
    browseIdeas: "تصفّح أفكار الذكاء الاصطناعي",
    addToCalendar: "أضِف إلى التقويم",
    addedToCalendar: "أُضيف إلى تقويمك",
    confirmSchedule: "أضِف",
    time: "الوقت",
    date: "التاريخ",
    title: "العنوان",
    titleRequired: "العنوان مطلوب",
    createEvent: "أنشئ فعالية",
    eventCreated: "تم نشر الفعالية في المحادثة",
    newEvent: "فعالية جديدة",
    eventTitlePlaceholder: "مثال: كرة الجمعة",
    youAccepted: "أنت ذاهب",
    youDeclined: "رفضت",
    going: "حاضرون",
    declined: "رافضون",
    responded: "تم الرد",
    profile: "الملف الشخصي",
    verified: "موثّق",
    notVerified: "غير موثّق",
    verifyMe: "وثّقني",
    yourMatches: "تطابقاتك",
    matchSubtitle: "أشخاص قريبون يشاركون اهتماماتك",
    distance: "المسافة",
    commonInterests: "اهتمامات مشتركة",
    commonLanguages: "لغات مشتركة",
    sameCity: "نفس المدينة",
    messageThem: "راسل",
    inviteToGroup: "دعوة إلى مجموعة",
    chooseGroup: "اختر مجموعة",
    sendInvite: "إرسال الدعوة",
    noGroups: "لم تنضم لأي مجموعة بعد.",
    createGroup: "أنشئ مجموعة",
    groupName: "اسم المجموعة",
    description: "الوصف",
    activity: "النشاط",
    maxMembers: "الحد الأقصى (حتى 10)",
    members: "الأعضاء",
    full: "ممتلئة",
    leaveGroup: "مغادرة المجموعة",
    groupChat: "محادثة المجموعة",
    typeMessage: "اكتب رسالة…",
    send: "إرسال",
    aiSuggest: "اقتراحات الذكاء الاصطناعي",
    suggestForGroup: "اقترح أنشطة",
    pending: "قيد الانتظار",
    accept: "قبول",
    reject: "رفض",
    noInvites: "لا توجد دعوات معلّقة.",
    noChats: "لا توجد محادثات بعد.",
    enableLocation: "تفعيل الموقع",
    useMyLocation: "استخدام موقعي",
    locationCaptured: "تم تحديد الموقع",
    radius: "نصف القطر",
    km: "كم",
    selectAtLeastOne: "اختر نشاطاً واحداً على الأقل",
    groupFull: "المجموعة ممتلئة",
    invitedSuccess: "تم إرسال الدعوة",
    accountCreated: "تم إنشاء الحساب — أهلاً!",
    invalidCreds: "اسم المستعار أو كلمة المرور غير صحيحة",
    aliasTaken: "الاسم المستعار محجوز",
    networkErr: "خطأ في الشبكة.",
    discoverEmpty: "لا توجد تطابقات بعد.",
    suggestions: "الاقتراحات",
    why: "لماذا تناسبكم",
    you: "أنت",
    online: "متصل",
    language: "اللغة",
    settings: "الإعدادات",
    yourProfile: "ملفك الشخصي",
    saving: "جارٍ الحفظ…",
    saved: "تم الحفظ",
    of: "من",
    members_count: "عضو",
    removePhoto: "إزالة الصورة",
    notifications: "الإشعارات",
    noNotifications: "أنت على اطلاع كامل.",
    markAllRead: "وضع علامة مقروء على الكل",
    unread: "غير مقروء",
    events: "الفعاليات",
    aiCuratedEvents: "فعاليات مختارة بالذكاء الاصطناعي",
    eventsSubtitle: "أفكار لقاءات مخصصة حسب اهتماماتك ومجموعاتك.",
    forYou: "لك",
    forGroup: "للمجموعة",
    generateEvents: "اقترح أفكاراً",
    refreshIdeas: "تحديث الأفكار",
    coverRegenerated: "غلاف جديد جاهز",
    allCategories: "الكل",
    generating: "يفكر…",
    eventsGenerated: "5 أفكار جديدة جاهزة!",
    noEvents: "لا توجد فعاليات بعد",
    noEventsHint: "اضغط «اقترح أفكاراً» للحصول على 5 أفكار لقاءات مخصصة لك.",
    openGroup: "افتح المجموعة",
    planWithGroup: "خطّط مع المجموعة",
  },
  ru: {
    appName: "SocialHub",
    tagline: "Знакомьтесь, делитесь моментами, живите рядом.",
    heroSub: "Сообщество с ИИ, где соседи с общими интересами встречаются в радиусе 5 км.",
    getStarted: "Начать",
    login: "Войти",
    register: "Создать аккаунт",
    logout: "Выйти",
    alias: "Псевдоним",
    password: "Пароль",
    city: "Город",
    languages: "Языки",
    primaryActivities: "Основные занятия",
    secondaryActivities: "Другие интересы",
    secondaryHint: "Через запятую: йога, сальса, настольные игры…",
    preferredGroupSize: "Предпочтительный размер группы",
    save: "Сохранить",
    cancel: "Отмена",
    submit: "Отправить",
    welcome: "С возвращением",
    createAccount: "Создайте аккаунт",
    haveAccount: "Уже есть аккаунт?",
    noAccount: "Впервые здесь?",
    discover: "Открыть",
    chats: "Чаты",
    groups: "Группы",
    invites: "Приглашения",
    calendar: "Календарь",
    yourCalendar: "Ваш календарь",
    calendarSubtitle: "Ваши идеи встреч в календаре.",
    hasEvents: "Есть события",
    event: "событие",
    eventsLabel: "события",
    nothingScheduled: "Ничего не запланировано.",
    browseIdeas: "Идеи от ИИ",
    addToCalendar: "Добавить в календарь",
    addedToCalendar: "Добавлено в календарь",
    confirmSchedule: "Запланировать",
    time: "Время",
    date: "Дата",
    title: "Название",
    titleRequired: "Требуется название",
    createEvent: "Создать событие",
    eventCreated: "Событие опубликовано в чате",
    newEvent: "Новое событие",
    eventTitlePlaceholder: "напр., Пятничный футбол",
    youAccepted: "Вы идёте",
    youDeclined: "Вы отказались",
    going: "Идут",
    declined: "Отказались",
    responded: "Ответили",
    profile: "Профиль",
    verified: "Подтверждён",
    notVerified: "Не подтверждён",
    verifyMe: "Подтвердить меня",
    yourMatches: "Ваши совпадения",
    matchSubtitle: "Люди рядом с общими интересами",
    distance: "Расстояние",
    commonInterests: "Общие интересы",
    commonLanguages: "Общие языки",
    sameCity: "Тот же город",
    messageThem: "Написать",
    inviteToGroup: "Пригласить в группу",
    chooseGroup: "Выберите группу",
    sendInvite: "Отправить приглашение",
    noGroups: "Вы пока не состоите в группах.",
    createGroup: "Создать группу",
    groupName: "Название группы",
    description: "Описание",
    activity: "Занятие",
    maxMembers: "Макс. участников (до 10)",
    members: "Участники",
    full: "Заполнено",
    leaveGroup: "Покинуть группу",
    groupChat: "Чат группы",
    typeMessage: "Введите сообщение…",
    send: "Отправить",
    aiSuggest: "Идеи от ИИ",
    suggestForGroup: "Предложить идеи",
    pending: "Ожидает",
    accept: "Принять",
    reject: "Отклонить",
    noInvites: "Нет ожидающих приглашений.",
    noChats: "Бесед пока нет.",
    enableLocation: "Включить точное местоположение",
    useMyLocation: "Моё местоположение",
    locationCaptured: "Местоположение получено",
    radius: "Радиус",
    km: "км",
    selectAtLeastOne: "Выберите хотя бы одно занятие",
    groupFull: "Группа заполнена",
    invitedSuccess: "Приглашение отправлено",
    accountCreated: "Аккаунт создан — добро пожаловать!",
    invalidCreds: "Неверный псевдоним или пароль",
    aliasTaken: "Псевдоним занят",
    networkErr: "Сетевая ошибка. Попробуйте снова.",
    discoverEmpty: "Совпадений пока нет.",
    suggestions: "Идеи",
    why: "Почему подходит",
    you: "Вы",
    online: "в сети",
    language: "Язык",
    settings: "Настройки",
    yourProfile: "Ваш профиль",
    saving: "Сохранение…",
    saved: "Сохранено",
    of: "из",
    members_count: "участников",
    removePhoto: "Удалить фото",
    notifications: "Уведомления",
    noNotifications: "Вы всё прочитали.",
    markAllRead: "Отметить все прочитанными",
    unread: "непрочитанные",
    events: "События",
    aiCuratedEvents: "События от ИИ",
    eventsSubtitle: "Персональные идеи встреч по вашим интересам и группам.",
    forYou: "Для вас",
    forGroup: "Для группы",
    generateEvents: "Создать идеи",
    refreshIdeas: "Обновить идеи",
    coverRegenerated: "Новая обложка готова",
    allCategories: "Все",
    generating: "Думаю…",
    eventsGenerated: "5 новых идей готово!",
    noEvents: "Событий пока нет",
    noEventsHint: "Нажмите «Создать идеи», чтобы получить 5 свежих идей встреч.",
    openGroup: "Открыть группу",
    planWithGroup: "Спланировать с группой",
  },
};

export const RTL_LANGS = ["ar"];
